import React from 'react';
import './footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/career">Career</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Head Office</h4>
          <ul>
            <li>25 Snowdrop Street</li>
            <li>Liverpool</li>
            <li>Merseyside</li>
            <li>L5 7RT</li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Daily Help United</h4>
          <p>Daily Help United Limited provides essential healthcare staffing to individuals, families, and healthcare organizations across the region.</p>
          <a href="mailto:info@dailyhelpunited.co.uk" className="email">info@dailyhelpunited.co.uk</a>
        </div>
      </div>

      <div className="footer-bottom">
        {/* <div className="social-icons">
          <FaFacebookF />
          <FaInstagram />
          <FaTwitter />
          <FaLinkedin />
        </div> */}
        <p className="copyright">
          2025 © Daily Help United. All rights reserved.<br/><br/>Designed by <Link to='https://tadeyemi.co.uk' target='_blank' rel='noreferrer'>Taiwo</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;